import './etc.css';

function Etc() {
  return (
    <div className="etc">
      <div className="etc-header">Etc</div>
      <div className="etc-container">

        <div className="etc-contents">
          <div className='etc-email'>
            <div className='etc-email-elem'>Email</div>
            <div className='etc-email-me'>alstkd1783@gmail.com</div>
          </div>

          <div className='etc-github'>
            <div>GitHub</div>
            <div><a href="https://github.com/satorufan" target="_blank" rel="noopener noreferrer">https://github.com/satorufan</a></div>
          </div>
          
          <div className='etc-sp'>
            <div>Simple Version</div>
            <div><a href="https://satorufan.github.io/portfolio/" target="_blank" rel="noopener noreferrer">Simple Portfolio Website</a></div>
          </div>

          <div className='etc-certification'>
            <div className='certification-header'>Certifications</div>
            <div className='certification-elem'>정보처리기사</div>
              
            <div className='certification-elem'>컴퓨터활용능력 1급</div>
            
            <div className='certification-elem'>Toeic Speaking 150(IH)</div>
          </div>

          {/* <div className='etc-sp-ed'>
            <div>Education</div>
            <div>대구대학교 - 전자공학전공 학사 (4.18)</div>
          </div> */}
          {/* <div className="etc-skills">
            <div className="skills-row">

              <div className="skills-column">
                <h3 className='etc-skill-header'>Language</h3>
                <div className='etc-skill-contents'>
                  <div className="etc-skill">
                    <img src={java} alt="Java" />
                    <span>Java</span>
                  </div>
                  <div className="etc-skill">
                    <img src={python} alt="Python" />
                    <span>Python</span>
                  </div>
                  <div className="etc-skill">
                    <img src={js} alt="JavaScript" />
                    <span>JavaScript</span>
                  </div>
                </div>
              </div>

              <div className="skills-column">
              <h3 className='etc-skill-header'>Front-End</h3>
              
              <div className='etc-skill-contents'>
                  <div className="etc-skill">
                    <img src={react} alt="React" />
                    <span>React</span>
                  </div>
                  <div className="etc-skill">
                    <img src={jsp} alt="Jsp" />
                    <span>JSP</span>
                  </div>
                  <div className="etc-skill">
                    <img src={ejs} alt="Ejs" />
                    <span>EJS</span>
                  </div>
                  <div className="etc-skill">
                    <img src={html} alt="HTML" />
                    <span>HTML</span>
                  </div>
                  <div className="etc-skill">
                    <img src={css} alt="CSS" />
                    <span>CSS</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="skills-row">
              <div className="skills-column">
              <h3 className='etc-skill-header'>Back-End</h3>
              
              <div className='etc-skill-contents'>
                <div className="etc-skill">
                  <img src={nodejs} alt="Node.js" />
                  <span>Node.js</span>
                </div>
                <div className="etc-skill">
                  <img src={spring} alt="Spring" />
                  <span>Spring</span>
                </div>
              </div>
            </div>

              <div className="skills-column">
                <h3 className='etc-skill-header'>Database</h3>
                
                <div className='etc-skill-contents'>
                  <div className="etc-skill">
                    <img src={mysql} alt="MySQL" />
                    <span>MySQL</span>
                  </div>
                  <div className="etc-skill">
                    <img src={mariadb} alt="MariaDB" />
                    <span>MariaDB</span>
                  </div>
                  <div className="etc-skill">
                    <img src={mongodb} alt="MongoDB" />
                    <span>MongoDB</span>
                  </div>
                  <div className="etc-skill">
                    <img src={firebase} alt="Firebase" />
                    <span>Firebase</span>
                  </div>
                  <div className="etc-skill">
                    <img src={redis} alt="Redis" />
                    <span>Redis</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="skills-row">
              <div className="skills-column">
                <h3 className='etc-skill-header'>Tools & Collaborations</h3>


                <div className='etc-skill-contents'>
                  <div className="etc-skill">
                    <img src={git} alt="Git" />
                    <span>Git</span>
                  </div>

                  <div className="etc-skill">
                    <img src={slack} alt="Slack" />
                    <span>Slack</span>
                  </div>
                  <div className="etc-skill">
                    <img src={discord} alt="Discord" />
                    <span>Discord</span>
                  </div>
                </div>

              </div>
            </div>
        </div> */}
        </div>
      </div>
    </div>
  );
}

export default Etc;
